import { imageUrl } from '@helpers/image';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import S from './HeaderRevamped.styles';
import CloseIcon from '@img/icons/close.svg';
import MenuIcon from '@img/icons/menu.svg';
import PhoneIcon from '@img/icons/phone.svg';
import SearchIcon from '@img/icons/search.svg';
import { FocusRing } from 'react-aria';
import MobileNavigation from './MobileNavigation/MobileNavigation';
import DesktopNavigation from './DesktopNavigation/DesktopNavigation';
const HeaderRevamped = (props) => {
    const [showSearch, setShowSearch] = React.useState(false);
    const [showMenu, setShowMenu] = React.useState(false);
    const [hasScrolled, setHasScrolled] = React.useState(false);
    const handleScroll = () => {
        const position = window.scrollY;
        position > 0 ? setHasScrolled(true) : setHasScrolled(false);
    };
    React.useEffect(() => {
        handleScroll();
    }, []);
    React.useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [hasScrolled]);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(S.Container, { "data-show-reduced": hasScrolled },
            React.createElement(S.TopArea, null,
                React.createElement(S.Inner, null,
                    React.createElement(S.Grid, null,
                        props.telephone && (React.createElement(S.ContactArea, null,
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.PhoneLink, { href: `tel:${props.telephone.url}`, id: "header-phone-link" },
                                    React.createElement(PhoneIcon, null),
                                    React.createElement(S.PhoneText, null, props.telephone.prefix),
                                    React.createElement(S.PhoneNumber, null,
                                        React.createElement("span", null, props.telephone.text)))))),
                        React.createElement(S.TopLinks, null,
                            props.topLinks && props.topLinks.length > 0 && (React.createElement(S.LinkList, null, props.topLinks.map((tl) => (React.createElement(S.TopLink, { key: `desktop-${tl.id}` },
                                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                    React.createElement("a", { href: tl.url, target: tl.target }, tl.text))))))),
                            props.loginCta && (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.LoginBtn, { href: props.loginCta?.url, target: props.loginCta?.target }, props.loginCta?.text ?? 'Login'))))))),
            React.createElement(S.MainContainer, null,
                React.createElement(S.SearchForm, { action: props.search.action, method: "get", "data-is-open": showSearch, id: "search-form" },
                    React.createElement(S.SearchInner, null,
                        React.createElement(S.InputWrapper, null,
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.SearchField, { type: "text", name: "searchTerm", placeholder: props.search.placeholder })),
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.SearchFormButton, { type: "submit", "aria-label": "Submit Search" }, "Search"))))),
                React.createElement(S.Inner, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.LogoWrapper, { href: "/" },
                            React.createElement(S.Logo, { src: imageUrl(props.logo, { width: 276, rmode: 'pad' }), alt: props.logo.altText ? props.logo.altText : 'Company Logo', loading: "eager", "data-logo-size": props.logoSize }),
                            React.createElement(S.LogoReduced, { src: imageUrl(props.logoReduced ?? props.logo, { width: 176, rmode: 'pad' }), alt: props.logoReduced?.altText ?? props.logo.altText
                                    ? props.logoReduced?.altText ?? props.logo.altText
                                    : 'Company Logo', loading: "lazy" }))),
                    React.createElement(S.ActionWrapper, { "data-action-open": showSearch || showMenu },
                        React.createElement(DesktopNavigation, { links: props.links }),
                        React.createElement(S.HeaderContent, null,
                            props.telephone && (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.PhoneLinkMobile, { href: `tel:${props.telephone.url}`, id: "header-mobile-phone-link" },
                                    React.createElement(S.PhoneNumber, null,
                                        React.createElement(PhoneIcon, null))))),
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.SearchButton, { onClick: () => setShowSearch(!showSearch), "aria-label": "Show Search" },
                                    React.createElement(SearchIcon, null))),
                            props.cta && (React.createElement(LinkButton, { buttonType: "default", href: props.cta.url, target: props.cta.target, id: "header-contact-button" }, props.cta.text)),
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.MenuButton, { onClick: () => {
                                        setShowMenu(true);
                                    }, "aria-label": "Open Menu" },
                                    React.createElement(MenuIcon, null))),
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.CloseButton, { onClick: () => {
                                        setShowSearch(false);
                                        setShowMenu(false);
                                    }, "aria-label": "Close Menu" },
                                    React.createElement(CloseIcon, null),
                                    "Close")))))),
            React.createElement(MobileNavigation, { links: props.links, isOpen: showMenu, topLinks: props.topLinks, telephone: props.telephone, loginCta: props.loginCta, contactLink: props.cta }))));
};
export default HeaderRevamped;
